// @flow

import { type Country } from '@tectonics/prs/country';
import { translateErrorMessagePT } from './error-messages-pt';
import { translateErrorMessageES } from './error-messages-es';

export function getTranslateErrorMessage(country: Country): (string) => ?string {
  switch (country) {
    case 'br':
      return translateErrorMessagePT;
    case 'ar':
    case 'bo':
    case 'ec':
    case 'cl':
    case 'co':
    case 'mx':
    case 'pe':
    case 'uy':
      return translateErrorMessageES;

    default:
      throw new Error(`getTranslateErrorMessage - country ${country} translate messages not supported`);
  }
}
